/**
 * @fileoverview POST handler for the "/engagement/canvas/:workflow_id/export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasWorkflowIdExportCacheKeys } from "./constants";
import type {
  PostEngagementCanvasWorkflowIdExportProps,
  EngagementCanvasExportResult,
  EngagementCanvasExportPayload,
} from "./types";

export const postEngagementCanvasExport = reactQueryMutationAdapter(
  engagementCanvasWorkflowIdExportCacheKeys,
  (props: PostEngagementCanvasWorkflowIdExportProps): Promise<EngagementCanvasExportResult> => {
    const payload: EngagementCanvasExportPayload = {
      app_group_id: props.appGroupId,
      custom_attributes: props.customAttributes,
      custom_events: props.customEvents,
      export_all_attributes: props.exportAllAttributes ?? false,
      only_email_addresses: props.onlyEmailAddresses ?? false,
    };

    if (props.exportPredictionScores) {
      payload.export_prediction_scores = props.exportPredictionScores;
    }

    return fetch(`/engagement/canvas/${props.workflowId}/export`, "POST", payload, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
